module.exports = __webpack_public_path__ + "media/141.42892543.mp3";